import { Component } from '@angular/core';
import { NavController, AlertController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { AppConfigProvider } from '../../providers/app-config/app-config';
import { LoginPage } from '../login/login';
@Component({
  selector: 'page-register',
  templateUrl: 'register.html'
})
export class RegisterPage { 
  username:string;
  email:string;
  password:string;
  title:string;
  subtitle:string;

  constructor
  (
    public navCtrl: NavController,
    private http:HttpClient,
    private appConfig:AppConfigProvider,
    private alertCtrl:AlertController,
  )
  {
    
  }

  signup(){
    // const formdata = new FormData();
    // formdata.append('username',this.username);
    // formdata.append('email',this.email);
    // formdata.append('password',this.password);
    // formdata.append('app_key',this.appConfig.appKey());

  	this.http.post(
      this.appConfig.apiUrl()+'index.php/api/login/register',
      {
        username: this.username,
        email: this.email,
        password: this.password,
        app_key: this.appConfig.appKey(),
      }
      )
    .subscribe((res:any) => {
      if(res.is_register){
        this.title = 'Success';
        this.subtitle = 'one new account created';
        this.alertMessage();

        this.navCtrl.push(LoginPage);
      }else{
        console.log('failed register the apps'+JSON.stringify(res));
        this.title = 'Failed';
        this.subtitle = 'Unable to register new account'+res.message;
        this.alertMessage();
      }
    },
    err => {
      console.log('failed request');
      this.title = 'Failed';
      this.subtitle = 'Registration process interupted';
      this.alertMessage();
    }
    );
  }

  alertMessage() {
    let alert = this.alertCtrl.create({
      title: this.title,
      subTitle: this.subtitle,
      buttons: ['Dismiss']
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts